import React, { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useI18n } from "../i18n/i18n";

/**
 * LanguageSwitcher — bouton + dropdown 🇫🇷 / 🇲🇬
 * Persiste la langue choisie dans localStorage via i18n context.
 */
export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang, t } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const flags = { fr: "🇫🇷", mg: "🇲🇬" };
  const labels = { fr: t("lang.fr"), mg: t("lang.mg") };

  return (
    <div ref={ref} className="relative" data-testid="lang-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 text-xs font-bold transition ${compact ? "" : ""}`}
        aria-label="Changer la langue"
        data-testid="lang-switcher-btn"
      >
        <span className="text-base leading-none">{flags[lang]}</span>
        {!compact && <span className="uppercase tracking-wider">{lang}</span>}
        <ChevronDown size={11} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div
          className="absolute right-0 top-full mt-2 z-50 min-w-[160px] bg-[#1a1411] border border-white/10 rounded-xl shadow-2xl overflow-hidden"
          data-testid="lang-switcher-dropdown"
        >
          {Object.keys(flags).map((code) => (
            <button
              key={code}
              onClick={() => { setLang(code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-white/5 transition ${
                lang === code ? "text-brand-orange font-bold" : "text-white/80"
              }`}
              data-testid={`lang-option-${code}`}
            >
              <span className="text-lg leading-none">{flags[code]}</span>
              <span className="flex-1 text-left">{labels[code]}</span>
              {lang === code && <span className="text-brand-orange">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
